import { render, staticRenderFns } from "./TechniqueTab.vue?vue&type=template&id=d6a568e2&"
import script from "./TechniqueTab.vue?vue&type=script&lang=js&"
export * from "./TechniqueTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports